import { usePathname } from 'next/navigation';

import type { ReactNode } from 'react';

type TopPageGradientProps = {
  children: ReactNode;
  excludedPaths?: string[];
};

export const TopPageGradient = ({ children, excludedPaths }: TopPageGradientProps) => {
  const pathname = usePathname();
  const isGradientVisible = !excludedPaths?.includes(pathname);

  return (
    <div className="relative flex flex-col flex-1">
      {isGradientVisible && (
        <div className="h-[14rem] bg-page-gradient absolute top-0 left-0 w-full" />
      )}
      <div className="relative z-1">{children}</div>
    </div>
  );
};
